import React, { useState } from "react";
import Header from "../components/Header";
import Header2 from "../components/Header2";
import Footer from "../components/Footer";

import "../assets/css/bootstrap.min.css";
import "../assets/css/style.css";
import "../assets/css/menu.css";
import "../assets/css/vendors.css";
import "../assets/css/icon_fonts/css/all_icons_min.css";
import "../assets/css/custom.css";

const doctorsData = [
  {
    name: "Dr. Priya Sharma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "15 Years Experience",
    location: "2nd Floor, MS Tower, Banjara Hills, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Buccal Fat Removal Specialist"
  },
  {
    name: "Dr. Anjali Mehta",
    qualification: "MBBS, MS - General Surgery, Fellowship - Facial Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.9/5",
    experience: "12 Years Experience",
    location: "Apurupa Urban, No 201, 2nd Floor, Image Gardens Rd, near Chirec School, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Facial Contouring Expert"
  },
  {
    name: "Dr. Rohan Verma",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.7/5",
    experience: "14 Years Experience",
    location: "Annapurna Kalyana Mandapam Srinagar Nagar, Dilsukhnagar, Hyderabad",
    phone: "080-6541-7705",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Cheek Slimming Specialist"
  },
  {
    name: "Dr. Sneha Reddy",
    qualification: "MBBS, MD - Dermatology, Fellowship - Aesthetic Medicine",
    fee: " FREE Consultation",
    rating: "4.6/5",
    experience: "11 Years Experience",
    location: "123 Green Avenue, Banjara Hills, Hyderabad",
    phone: "080-6541-7710",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Non-Surgical Facial Slimming"
  },
  {
    name: "Dr. Kavita Patel",
    qualification: "MBBS, MS - General Surgery, MCh - Plastic Surgery",
    fee: " FREE Consultation",
    rating: "4.8/5",
    experience: "16 Years Experience",
    location: "45 Tower Road, Jubilee Hills, Hyderabad",
    phone: "080-6541-7720",
    online: true,
    image: "/assets/img/doctors/doctor1.jpg",
    specialization: "Advanced Buccal Fat Removal"
  },
  {
    name: "Dr. Arjun Kumar",
    qualification: "MBBS, MS - ENT, Fellowship - Facial Cosmetic Surgery",
    fee: "FREE Consultation",
    rating: "4.7/5",
    experience: "13 Years Experience",
    location: "21 MG Road, Hyderabad",
    phone: "080-6541-7730",
    online: false,
    image: "/assets/img/doctors/doctor2.jpg",
    specialization: "Facial Harmony Expert"
  },
];

const DoctorsSection = () => {
  const [showAll, setShowAll] = useState(false);
  const displayedDoctors = showAll ? doctorsData : doctorsData.slice(0, 6);

  return (
    <div style={{ padding: "80px 20px", backgroundColor: "#f8f9fa" }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto", fontFamily: "'Poppins', sans-serif" }}>
        <div style={{ textAlign: "center", marginBottom: "50px" }}>
          <h2 style={{ fontSize: "42px", fontWeight: "800", color: "#0b1c39", marginBottom: "15px" }}>
            Our <span style={{ color: "#ffcb24" }}>Buccal Fat Treatment Specialists</span>
          </h2>
          <p style={{ fontSize: "18px", color: "#555", maxWidth: "600px", margin: "0 auto", lineHeight: "1.8" }}>
            Expert surgical care for facial contouring with buccal fat removal for defined cheekbones and elegant facial structure.
          </p>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "25px", justifyContent: "space-between" }}>
          {displayedDoctors.map((doc, index) => (
            <div
              key={index}
              style={{
                flex: "0 0 calc(33.33% - 17px)",
                backgroundColor: "#fff",
                borderRadius: "16px",
                padding: "25px",
                boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                border: "1px solid rgba(9,187,175,0.1)",
                transition: "transform 0.3s ease, box-shadow 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 12px 35px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)";
              }}
            >
              <div style={{ position: "relative", flexShrink: 0 }}>
                <img
                  src={doc.image}
                  alt={doc.name}
                  style={{
                    width: "95px",
                    height: "95px",
                    borderRadius: "50%",
                    objectFit: "cover",
                    border: "3px solid #09bbaf",
                    backgroundColor: "#f8f8f8",
                  }}
                />
                {doc.online && (
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "8px",
                      width: "14px",
                      height: "14px",
                      backgroundColor: "#09bbaf",
                      borderRadius: "50%",
                      border: "2px solid #fff",
                    }}
                    title="Online"
                  ></span>
                )}
              </div>

              <div style={{ flex: 1 }}>
                <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#0b1c39", marginBottom: "6px" }}>
                  {doc.name}
                </h3>
                <p style={{ color: "#09bbaf", fontSize: "14px", marginBottom: "6px", fontWeight: "600" }}>
                  {doc.specialization}
                </p>
                <p style={{ color: "#555", fontSize: "14px", marginBottom: "6px" }}>
                  {doc.qualification}
                </p>
                <p style={{ fontWeight: "600", color: "#09bbaf", marginBottom: "6px", fontSize: "15px" }}>
                  {doc.fee}
                </p>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "6px" }}>
                  <span style={{ fontSize: "14px", color: "#555" }}>⭐ {doc.rating}</span>
                  <span style={{ fontSize: "14px", color: "#555" }}>{doc.experience}</span>
                </div>
                <p style={{ fontSize: "13px", color: "#555", display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "6px", lineHeight: "1.4" }}>
                  📍 {doc.location}
                </p>
                <p style={{ fontSize: "13px", color: "#555", marginBottom: "15px" }}>
                  📞 {doc.phone}
                </p>

                <button
                  style={{
                    padding: "12px 20px",
                    border: "none",
                    borderRadius: "30px",
                    backgroundColor: "#ffcb24",
                    color: "#0b1c39",
                    cursor: "pointer",
                    width: "100%",
                    fontWeight: "600",
                    fontSize: "14px",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#ffd84f")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#ffcb24")}
                >
                  Book Free Consultation
                </button>
              </div>
            </div>
          ))}
        </div>

        {!showAll && doctorsData.length > 6 && (
          <div style={{ textAlign: "center", marginTop: "40px" }}>
            <button
              onClick={() => setShowAll(true)}
              style={{
                padding: "14px 40px",
                fontSize: "16px",
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#09bbaf",
                color: "#fff",
                cursor: "pointer",
                fontWeight: "700",
                boxShadow: "0 8px 25px rgba(9,187,175,0.3)",
                transition: "background-color 0.3s ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#0dcfc2")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#09bbaf")}
            >
              View More Doctors ▼
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const BuccalFatTreatment = () => {
  const [activeTab, setActiveTab] = useState("overview");

  return (
    <>
      <Header />
      <Header2 />

      {/* Hero Section */}
      <section style={{
        background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
        padding: "160px 0 100px",
        marginTop: "56px",
        color: "white",
        textAlign: "center",
        position: "relative",
        overflow: "hidden"
      }}>
        <div className="container" style={{ position: "relative", zIndex: 2 }}>
          <h1 style={{
            fontSize: "3.5rem",
            fontWeight: "800",
            marginBottom: "20px",
            color: "white"
          }}>
            Advanced Buccal Fat Treatment
          </h1>
          <p style={{
            fontSize: "1.3rem",
            marginBottom: "30px",
            opacity: "0.9",
            maxWidth: "700px",
            margin: "0 auto 30px",
            lineHeight: "1.6"
          }}>
            Facial Contouring with 96% Success Rate. Achieve Defined Cheekbones and Elegant Facial Structure with Precision Surgery.
          </p>
          <div style={{ display: "flex", justifyContent: "center", gap: "20px", flexWrap: "wrap" }}>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book Free Consultation
            </button>
            <button style={{
              padding: "15px 35px",
              borderRadius: "30px",
              border: "2px solid #ffcb24",
              backgroundColor: "transparent",
              color: "#ffcb24",
              fontWeight: "700",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.color = "#0b1c39";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "transparent";
              e.currentTarget.style.color = "#ffcb24";
            }}>
              Virtual Results Preview
            </button>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section style={{ backgroundColor: "#fff", padding: "60px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>96%</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Patient Satisfaction</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>30-45</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Minutes Procedure</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>1-2</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Weeks Recovery</p>
              </div>
            </div>
            <div className="col-md-3 col-6 text-center">
              <div>
                <h2 style={{ color: "#09bbaf", fontWeight: "800", fontSize: "2.5rem", marginBottom: "10px" }}>15+</h2>
                <p style={{ color: "#0b1c39", fontWeight: "600" }}>Years Expert Team</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Doctors Section */}
      <DoctorsSection />

      {/* Navigation Tabs */}
      <section style={{ backgroundColor: "#fff", padding: "40px 0", borderBottom: "1px solid #eee" }}>
        <div className="container">
          <div style={{ display: "flex", justifyContent: "center", gap: "10px", flexWrap: "wrap" }}>
            {[
              { id: "overview", label: "Overview", icon: "📋" },
              { id: "benefits", label: "Benefits", icon: "✨" },
              { id: "candidates", label: "Candidates", icon: "🎯" },
              { id: "procedure", label: "Procedure", icon: "🔬" },
              { id: "recovery", label: "Recovery", icon: "⚕️" },
              { id: "results", label: "Results", icon: "🔄" },
              { id: "faq", label: "FAQ", icon: "🛡️" }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                style={{
                  padding: "12px 24px",
                  borderRadius: "25px",
                  border: "none",
                  backgroundColor: activeTab === tab.id ? "#09bbaf" : "#f8f9fa",
                  color: activeTab === tab.id ? "white" : "#555",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s ease"
                }}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <div className="container" style={{ padding: "80px 15px" }}>

        {/* Comprehensive Overview */}
        <section style={{ marginBottom: "80px" }}>
          <div style={{ textAlign: "center", marginBottom: "60px" }}>
            <h2 style={{ fontSize: "36px", fontWeight: "800", color: "#0b1c39", marginBottom: "20px" }}>
              Complete Guide to <span style={{ color: "#09bbaf" }}>Buccal Fat Treatment</span>
            </h2>
          </div>

          {/* What is Buccal Fat */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "50px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "1px solid rgba(9,187,175,0.1)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px" }}>
                Understanding Buccal Fat Pad
              </h3>
              
              <p style={{ color: "#555", lineHeight: "1.8", fontSize: "1.1rem", marginBottom: "25px" }}>
                The buccal fat pad is a naturally occurring fat compartment located in the cheeks, between 
                the facial muscles. This encapsulated fat pad contributes to the roundness of the lower cheeks 
                and is responsible for the "chipmunk cheek" appearance in some individuals. Buccal fat removal 
                is a surgical procedure that reduces cheek fullness for enhanced facial contouring.
              </p>

              <div className="row">
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #09bbaf",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Anatomical Location</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Located deep in the cheeks between the masseter muscle and buccinator muscle, 
                      the buccal fat pad is separate from subcutaneous facial fat and doesn't fluctuate 
                      with weight changes.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{
                    backgroundColor: "#f8f9fa",
                    borderRadius: "15px",
                    padding: "25px",
                    borderLeft: "4px solid #ffcb24",
                    marginBottom: "25px"
                  }}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px" }}>Functional Purpose</h5>
                    <p style={{ color: "#555", margin: 0 }}>
                      Serves as a cushion between facial muscles, facilitates smooth muscle movement during 
                      chewing, and provides insulation. Removal doesn't affect normal facial functions when 
                      performed correctly.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefits & Advantages */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Benefits & Advantages of Buccal Fat Removal
            </h3>

            <div className="row">
              {[
                {
                  title: "Enhanced Facial Contouring", 
                  description: "Creates more defined cheekbones and elegant facial structure by reducing cheek fullness",
                  details: "Achieves V-shaped or heart-shaped face appearance"
                },
                {
                  title: "Permanent Results", 
                  description: "Provides long-lasting facial slimming as buccal fat doesn't regenerate once removed",
                  details: "Lifetime results with proper surgical technique"
                },
                {
                  title: "Minimal Downtime", 
                  description: "Quick recovery with most patients returning to normal activities within 3-5 days",
                  details: "Outpatient procedure with local anesthesia"
                },
                {
                  title: "Natural-looking Results", 
                  description: "Subtle enhancement that appears natural and proportional to your facial features",
                  details: "Preserves natural facial expressions"
                },
                {
                  title: "No Visible Scars", 
                  description: "Incisions made inside mouth leaving no external scars or visible marks",
                  details: "Completely hidden surgical approach"
                },
                {
                  title: "Boosted Confidence", 
                  description: "Significant improvement in facial appearance leading to enhanced self-esteem",
                  details: "Life-changing cosmetic improvement"
                }
              ].map((benefit, index) => (
                <div key={index} className="col-lg-4 col-md-6 mb-4">
                  <div style={{
                    backgroundColor: "#fff",
                    borderRadius: "15px",
                    padding: "25px",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                    border: "1px solid rgba(9,187,175,0.1)",
                    height: "100%",
                    transition: "transform 0.3s ease"
                  }}
                  onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-5px)"}
                  onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0)"}>
                    <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                      {benefit.title}
                    </h5>
                    <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                      {benefit.description}
                    </p>
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "8px",
                      padding: "12px",
                      borderLeft: "3px solid #09bbaf"
                    }}>
                      <p style={{ color: "#666", fontSize: "0.9rem", lineHeight: "1.5", margin: 0 }}>
                        {benefit.details}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Candidate Types & Classification */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Ideal Candidates & Facial Types
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    type: "Round Face Shape",
                    description: "Individuals with naturally full, round faces seeking more angular facial contours",
                    treatment: "Excellent candidates for significant improvement"
                  },
                  {
                    type: "Young Adults (25-35)",
                    description: "Ideal age range when facial features are mature but before natural age-related volume loss",
                    treatment: "Optimal timing for permanent results"
                  },
                  {
                    type: "Good Skin Elasticity",
                    description: "Patients with firm, elastic skin that will contract smoothly after fat removal",
                    treatment: "Ensures smooth contour without sagging"
                  },
                  {
                    type: "Healthy BMI",
                    description: "Individuals at or near their ideal body weight with localized cheek fullness",
                    treatment: "Best results in normal weight range"
                  },
                  {
                    type: "Non-Smokers",
                    description: "Patients who don't smoke for optimal healing and reduced complication risks",
                    treatment: "Faster recovery and better outcomes"
                  },
                  {
                    type: "Realistic Expectations",
                    description: "Individuals understanding this enhances natural features rather than dramatic transformation",
                    treatment: "Proper consultation and planning"
                  }
                ].map((type, index) => (
                  <div key={index} className="col-lg-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      border: "2px solid #09bbaf",
                      height: "100%"
                    }}>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.2rem" }}>
                        {type.type}
                      </h5>
                      <p style={{ color: "#555", fontSize: "1rem", lineHeight: "1.6", marginBottom: "15px" }}>
                        {type.description}
                      </p>
                      <div style={{
                        backgroundColor: "#09bbaf",
                        color: "white",
                        padding: "8px 15px",
                        borderRadius: "20px",
                        display: "inline-block",
                        fontSize: "0.9rem",
                        fontWeight: "600"
                      }}>
                        {type.treatment}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Considerations & Contraindications */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#0b1c39",
              borderRadius: "20px",
              padding: "50px",
              color: "white"
            }}>
              <h3 style={{ fontSize: "28px", fontWeight: "800", marginBottom: "30px", color: "#ffcb24" }}>
                Important Considerations & Contraindications
              </h3>
              
              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Poor Candidates</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Individuals with naturally thin or narrow faces</li>
                      <li style={{ marginBottom: "10px" }}>Patients over 40 with natural volume loss</li>
                      <li style={{ marginBottom: "10px" }}>Those with significant weight fluctuations</li>
                      <li style={{ marginBottom: "10px" }}>People with certain medical conditions</li>
                      <li>Smokers unable to quit before surgery</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#ffcb24", fontWeight: "700", marginBottom: "15px" }}>Important Considerations</h5>
                    <ul style={{ color: "rgba(255,255,255,0.9)", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Results are permanent and cannot be reversed</li>
                      <li style={{ marginBottom: "10px" }}>Natural aging will continue after procedure</li>
                      <li style={{ marginBottom: "10px" }}>Asymmetry correction may require different amounts per side</li>
                      <li style={{ marginBottom: "10px" }}>Combination with other procedures often recommended</li>
                      <li>Realistic expectations are crucial for satisfaction</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Treatment Options */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Comprehensive Treatment Approaches
            </h3>

            <div className="row">
              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #09bbaf",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Non-Surgical Alternatives
                  </h4>
                  
                  <p style={{ color: "#555", lineHeight: "1.8", marginBottom: "25px" }}>
                    For patients not ready for surgery or with minimal cheek fullness, non-surgical 
                    options can provide temporary facial slimming and contouring effects.
                  </p>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Injectable Treatments:</h6>
                    <div className="row">
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Masseter Botox</li>
                          <li style={{ marginBottom: "8px" }}>Deoxycholic acid injections</li>
                          <li style={{ marginBottom: "8px" }}>Thread lifts</li>
                        </ul>
                      </div>
                      <div className="col-6">
                        <ul style={{ color: "#555", paddingLeft: "20px", fontSize: "0.95rem" }}>
                          <li style={{ marginBottom: "8px" }}>Ultherapy</li>
                          <li style={{ marginBottom: "8px" }}>Radiofrequency treatments</li>
                          <li style={{ marginBottom: "8px" }}>Facial exercises</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Limitations:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "8px" }}>Temporary results (6-18 months)</li>
                      <li style={{ marginBottom: "8px" }}>Limited effectiveness for significant fullness</li>
                      <li style={{ marginBottom: "8px" }}>Multiple sessions required</li>
                      <li>Cannot remove buccal fat pad directly</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 mb-4">
                <div style={{
                  backgroundColor: "#fff",
                  borderRadius: "20px",
                  padding: "40px",
                  boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                  border: "2px solid #ffcb24",
                  height: "100%"
                }}>
                  <h4 style={{ color: "#0b1c39", marginBottom: "25px", fontSize: "24px", fontWeight: "800" }}>
                    Surgical Buccal Fat Removal
                  </h4>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Surgical Procedure:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Small incisions inside mouth (no external scars)</li>
                      <li style={{ marginBottom: "10px" }}>Local anesthesia with sedation or general anesthesia</li>
                      <li style={{ marginBottom: "10px" }}>Precise removal of predetermined amount of buccal fat</li>
                      <li style={{ marginBottom: "10px" }}>30-45 minute procedure time</li>
                      <li>Dissolvable stitches that don't require removal</li>
                    </ul>
                  </div>

                  <div style={{ marginBottom: "25px" }}>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Advanced Techniques:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px", marginBottom: "25px" }}>
                      <li style={{ marginBottom: "10px" }}>Conservative fat removal to avoid over-resection</li>
                      <li style={{ marginBottom: "10px" }}>Asymmetry correction with differential removal</li>
                      <li style={{ marginBottom: "10px" }}>Combination with liposuction for comprehensive contouring</li>
                      <li style={{ marginBottom: "10px" }}>3D imaging for surgical planning</li>
                      <li>Customized approach based on facial anatomy</li>
                    </ul>
                  </div>

                  <div>
                    <h6 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Combination Procedures:</h6>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Chin augmentation for balanced profile</li>
                      <li style={{ marginBottom: "10px" }}>Rhinoplasty for overall facial harmony</li>
                      <li style={{ marginBottom: "10px" }}>Neck liposuction for complete lower face contouring</li>
                      <li>Facelift for mature patients</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Surgical Procedure Timeline */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Surgical Procedure & Recovery Timeline
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              <div className="row">
                {[
                  {
                    period: "Day 1-3",
                    title: "Initial Recovery",
                    activities: ["Swelling and bruising peak", "Soft foods diet", "Pain management", "Limited talking"]
                  },
                  {
                    period: "Day 4-7",
                    title: "Early Healing",
                    activities: ["Swelling reduces 50-70%", "Return to work", "Light activities", "Stitches dissolve"]
                  },
                  {
                    period: "Week 2-4",
                    title: "Visible Improvement",
                    activities: ["Major swelling resolves", "Facial contours emerge", "Normal diet resumes", "Exercise resumes"]
                  },
                  {
                    period: "Month 2-3",
                    title: "Final Results",
                    activities: ["Final contours visible", "All swelling resolved", "Natural appearance", "Complete healing"]
                  }
                ].map((stage, index) => (
                  <div key={index} className="col-lg-3 col-md-6 mb-4">
                    <div style={{
                      backgroundColor: "#f8f9fa",
                      borderRadius: "15px",
                      padding: "25px",
                      textAlign: "center",
                      border: "1px solid rgba(9,187,175,0.2)",
                      height: "100%"
                    }}>
                      <div style={{ 
                        backgroundColor: "#09bbaf", 
                        color: "white", 
                        width: "60px", 
                        height: "60px", 
                        borderRadius: "50%", 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        margin: "0 auto 15px",
                        fontWeight: "700",
                        fontSize: "0.9rem"
                      }}>
                        {stage.period}
                      </div>
                      <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "15px", fontSize: "1.1rem" }}>
                        {stage.title}
                      </h5>
                      <ul style={{ color: "#555", fontSize: "0.85rem", paddingLeft: "15px", textAlign: "left" }}>
                        {stage.activities.map((activity, idx) => (
                          <li key={idx} style={{ marginBottom: "8px" }}>{activity}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Prevention & Aftercare */}
          <div style={{ marginBottom: "60px" }}>
            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
              border: "2px solid rgba(255,203,36,0.3)"
            }}>
              <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "30px", textAlign: "center" }}>
                Post-operative Care & Instructions
              </h3>

              <div className="row">
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Immediate Post-op Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Cold compresses for 48 hours to reduce swelling</li>
                      <li style={{ marginBottom: "10px" }}>Soft foods and liquids for 3-5 days</li>
                      <li style={{ marginBottom: "10px" }}>Elevate head while sleeping</li>
                      <li>Avoid strenuous activity for 2 weeks</li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-6">
                  <div style={{ marginBottom: "25px" }}>
                    <h5 style={{ color: "#09bbaf", fontWeight: "700", marginBottom: "15px" }}>Long-term Care</h5>
                    <ul style={{ color: "#555", paddingLeft: "20px" }}>
                      <li style={{ marginBottom: "10px" }}>Maintain stable weight for consistent results</li>
                      <li style={{ marginBottom: "10px" }}>Good oral hygiene to prevent infection</li>
                      <li style={{ marginBottom: "10px" }}>Regular follow-up appointments</li>
                      <li>Sun protection for facial skin</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* FAQ Section */}
          <div style={{ marginBottom: "60px" }}>
            <h3 style={{ color: "#0b1c39", fontSize: "28px", fontWeight: "800", marginBottom: "40px", textAlign: "center" }}>
              Frequently Asked Questions
            </h3>

            <div style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
            }}>
              {[
                {
                  question: "Is buccal fat removal painful?",
                  answer: "Buccal fat removal is generally well-tolerated with minimal pain. During the procedure, local anesthesia or sedation ensures you're comfortable and pain-free. After surgery, most patients describe the discomfort as mild to moderate soreness, similar to having a tooth extraction. The inside of the cheeks may feel tender and swollen for the first 3-5 days. Pain is typically managed effectively with over-the-counter pain relievers like acetaminophen, and most patients don't require prescription pain medication. The discomfort peaks within the first 48 hours and diminishes rapidly thereafter. Many patients compare the post-operative sensation to having worked out their facial muscles intensely. By day 4-5, most patients report only minor tenderness that resolves completely within 1-2 weeks. Proper post-operative care including cold compresses and soft diet significantly minimizes discomfort."
                },
                {
                  question: "How long do buccal fat removal results last?",
                  answer: "Buccal fat removal provides permanent results because the buccal fat pad does not regenerate once removed. The fat cells that are surgically removed are gone permanently, and your body does not grow new buccal fat pads. However, it's important to understand that while the specific buccal fat is permanently removed, your face will still undergo natural aging changes. As you age, you'll naturally lose facial fat in other areas, which is a normal part of the aging process. Significant weight fluctuations can also affect your overall facial appearance, though the buccal area itself will remain slimmer compared to how it would appear without the surgery. The procedure is considered permanent, and the enhanced facial contouring will be maintained throughout your life, though it will exist within the context of your natural aging progression. This is why conservative removal is often recommended, especially for younger patients."
                },
                {
                  question: "When will I see final results after buccal fat removal?",
                  answer: "The timeline for seeing final results after buccal fat removal follows a predictable pattern. Immediately after surgery, significant swelling masks the results, and your face may actually appear fuller than before the procedure. Within 2-4 weeks, about 70-80% of the swelling resolves, and you'll begin to see noticeable improvement in your facial contours. By 6-8 weeks, most of the swelling has diminished, and the new facial shape becomes clearly visible. However, the final results typically emerge around the 3-month mark when all residual swelling has completely resolved. Some subtle refinement may continue for up to 6 months as the tissues fully settle. It's important to have patience during the healing process and not judge the results too early. Your surgeon will monitor your progress through follow-up appointments and can show you comparative photos to help you appreciate the transformation as it unfolds gradually."
                },
                {
                  question: "Can buccal fat removal make me look older?",
                  answer: "When performed conservatively and on appropriate candidates, buccal fat removal should not make you look older. The key is proper patient selection and conservative fat removal. The procedure is designed to enhance your natural facial contours by reducing cheek fullness, not to remove essential facial volume. However, if too much fat is removed or if the procedure is performed on someone who already has minimal facial fat, it could potentially lead to a prematurely aged appearance as natural aging progresses. This is why experienced surgeons carefully evaluate each patient's facial structure, age, and skin quality before recommending this procedure. Ideal candidates are typically in their 20s to mid-30s with good skin elasticity and naturally full cheeks. The goal is to create a more sculpted appearance that will age gracefully with you, not to dramatically hollow out the cheeks. A skilled surgeon will remove just enough fat to enhance your features while preserving a youthful appearance."
                },
                {
                  question: "What's the difference between buccal fat removal and masseter Botox?",
                  answer: "Buccal fat removal and masseter Botox are two different procedures that address facial fullness through completely different mechanisms. Buccal fat removal is a surgical procedure that permanently removes the buccal fat pads located in the lower cheeks. This directly reduces cheek fullness and creates more defined facial contours. Masseter Botox involves injecting botulinum toxin into the masseter muscles (jaw muscles) to temporarily relax and shrink these muscles. This reduces jawline width and can create a slimmer lower face appearance, but doesn't affect cheek fullness. Key differences include: Buccal fat removal is permanent, while masseter Botox lasts 6-9 months; Buccal fat addresses cheek fullness, masseter Botox addresses jaw width; Surgical vs non-surgical approach; Different recovery times and mechanisms. Some patients benefit from combining both procedures for comprehensive facial slimming. Your surgeon can recommend the best approach based on your specific facial anatomy and goals during consultation."
                }
              ].map((faq, index) => (
                <div key={index} style={{ 
                  marginBottom: "25px",
                  paddingBottom: "25px",
                  borderBottom: index < 4 ? "1px solid #eee" : "none"
                }}>
                  <h5 style={{ color: "#0b1c39", fontWeight: "700", marginBottom: "10px" }}>
                    {faq.question}
                  </h5>
                  <p style={{ color: "#555", lineHeight: "1.6", margin: 0 }}>
                    {faq.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Final CTA */}
          <div style={{
            background: "linear-gradient(135deg, #0b1c39 0%, #09bbaf 100%)",
            borderRadius: "20px",
            padding: "60px 40px",
            textAlign: "center",
            color: "white"
          }}>
            <h2 style={{ fontSize: "2.5rem", fontWeight: "800", marginBottom: "20px" }}>
              Ready for Defined Facial Contours?
            </h2>
            <p style={{ fontSize: "1.2rem", marginBottom: "30px", opacity: "0.9", maxWidth: "600px", margin: "0 auto 30px" }}>
              Our expert surgeons provide precision buccal fat removal for enhanced facial harmony and natural-looking results.
            </p>
            <button style={{
              padding: "18px 45px",
              borderRadius: "30px",
              border: "none",
              backgroundColor: "#ffcb24",
              color: "#0b1c39",
              fontWeight: "800",
              fontSize: "1.1rem",
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#ffd84f";
              e.currentTarget.style.transform = "translateY(-2px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffcb24";
              e.currentTarget.style.transform = "translateY(0)";
            }}>
              Book FREE Consultation Now
            </button>
            <p style={{ marginTop: "20px", fontSize: "1rem", opacity: "0.8" }}>
              Plastic Surgery: <strong>080-6541-7705</strong> | Cosmetic Surgery: <strong>080-6541-7715</strong>
            </p>
          </div>
        </section>
      </div>

      <Footer />
    </>
  );
};

export default BuccalFatTreatment;